"use client";

import { Route, Routes } from "react-router-dom";
import { LawFirmsProvider } from "../../../features/lawFirms/context/LawFirmsContext";
import { LawFirmsCreate } from "./LawFirmsCreate";
import { LawFirmsDetail } from "./LawFirmsDetail";
import { LawFirmsList } from "./LawFirmsList";

export const LawFirmsRoutes = () => {
  return (
    <LawFirmsProvider>
      <Routes>
        <Route path="/" element={<LawFirmsList />} />
        <Route path="/new" element={<LawFirmsCreate />} />
        <Route path=":lawFirmId" element={<LawFirmsDetail />} />
      </Routes>
    </LawFirmsProvider>
  );
};
